export const visitorSiteConfig = {
  siteId: "buttered",
  siteName: "Buttered",
  excludedPathPrefixes: [],
} as const;
